export enum TaskType {
  REGULAR = 'REGULAR',
  INTERACTIVEISOMETRIC = 'INTERACTIVEISOMETRIC',
}
